import Layout from "../layout";

/**
 * 根据children层级自动生成侧边栏路由
 * @meta icon 对应elementui icon图标
 * @meta auth 鉴权参数
 */
const menuRouter = {
  path: "/",
  component: Layout,
  children: [
    {
      path: "/",
      name: "首页",
      component: () => import("../views/index.vue"),
      meta: {
        icon: "el-icon-s-home",
        auth: [],
      },
    },
    {
      path: "/job",
      name: "人才库",
      component: () => import("../views/job.vue"),
      meta: {
        icon: "el-icon-suitcase",
        auth: [],
      },
    },
    {
      path: "/cooperation",
      name: "合作库",
      component: () => import("../views/cooperation.vue"),
      meta: {
        icon: "el-icon-connection",
        auth: [],
      },
    },
  ],
};
export default menuRouter;
